
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGInspectionValuesDialog extends Serenity.EntityDialog<MFGInspectionValuesRow, any> {
        protected getFormKey() { return MFGInspectionValuesForm.formKey; }
        protected getIdProperty() { return MFGInspectionValuesRow.idProperty; }
        protected getLocalTextPrefix() { return MFGInspectionValuesRow.localTextPrefix; }
        protected getNameProperty() { return MFGInspectionValuesRow.nameProperty; }
        protected getService() { return MFGInspectionValuesService.baseUrl; }
        protected getDeletePermission() { return MFGInspectionValuesRow.deletePermission; }
        protected getInsertPermission() { return MFGInspectionValuesRow.insertPermission; }
        protected getUpdatePermission() { return MFGInspectionValuesRow.updatePermission; }

        protected form = new MFGInspectionValuesForm(this.idPrefix);

    }
}